import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearDetailAccounts,
  clearInvoiceDetail,
  confirmInvoice,
  createNewInvoice,
  getDetailAccounts,  
  getReasons,
  updatedDetail,
  // updateReason,
  updateRegime
} from "../../../store/actions/precog";
import "./style.css";
import ContiContabiliTable from "./contiContabili";
import ContiIvaTable from "./contiIva";
import moment from "moment";
import BottomBar from "./bottomBar";
import { displaySuccessToast } from "../../../store/actions/overflowNotification";
import { openEinvoicePreview } from "../../../store/actions/detailsDocument/preview";

import LoaderSimple from "../../general/loader";
import { startDownloadData } from "../../../libs/utils";
import { resetDownloadDocument } from "../../../store/actions/download";
import uuidv4 from "uuid/v4";
import {
  checkErrors,
  checkReasonChange,
  getReasonParams,
  unmergeAccountingLines
} from "../utils";
// import InfoHeaderNew from "./header/infoHeaderNew";
import Intrastat from "./intrastat";
import { getDeadlineDetail } from "../../../store/actions/deadlines/detail";
import { FormattedMessage } from "react-intl";
// import { deadlinesFilters } from "../../deadlines/shared";
import {
  clearVatLines,
  getVatCompensation,
  getVatDestinations,
  getVatExemptions,
  getVatFlatRates,
  getVatLines,
  getVatRegimes
} from "../../../store/actions/precog/vat";
import Assets from "./accountAssets";
import { clearAccountArticles, getAccountArticles, updateAccountingLine } from "../../../store/actions/precog/accountingLines";
import Withholding from "./withholding/index";
import FiscalPayments from "./fiscalPayments";
import DetailTabs from "./detailTabs";
import PreviewDocumentModal from "./previewDocumentModal";
import ReloadModal from "./reloadModal";
import { getDashboardData } from "../../../store/actions/precog/accounting";
import UsedGoods from "./usedGoods";
import { getGroupId } from "./contiContabili/methods";
import InfoHeader from "./header/infoHeader";
import SelectReasonsForm from "./header/selectReasonsForm";

const PreCogDetailPage = ({setReason, reasonsActive,
  createReason, isCreate, formByReason,
  isFromRegistration, backUrlLink, isFromAccountantPage, setIsFromAccountantPage }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const detail = useSelector(state => state.precog.invoiceDetail.data);
  const accounts = useSelector(state => state.precog.detailAccounts.data);
  const vatLines = useSelector(state => state.precog.vat.lines);
  const draftIds = useSelector(state => state.precog.dashboardData.draftIds);
  const accountArticles = useSelector(state => state.precog.accountArticles.data);

  // const deadlineDetail = useSelector(state => state.deadlinesDetail.subjective);
  const isGettingDetail = useSelector(state => state.precog.invoiceDetail.status?.started);
  const accountsToRefresh = useSelector(state => state.precog.detailAccounts.status?.isToRefresh);
  const isUpdatingDetail = useSelector(state => state.precog.updatedDetail.status?.started);

  const download = useSelector(state => state.download);

  const [drafIdByUrl, setDrafIdByUrl] = useState(null);
  const [newDetail, setNewDetail] = useState({});
  const [contiNew, setContiNew] = useState([]);
  // const [withHoldingNew, setWithHoldingNew] = useState([]);
  // const [residue, setResidue] = useState(0);  
  const [previewModal, setPreviewModal] = useState(false);
  const [sectionalError, setSectionalError] = useState(false);
  const [einvoiceType, setEinvoiceType] = useState("ASSOSW");
  const [showWithholding, setShowWithholding] = useState(false);
  const [showvatCollectability, setShowvatCollectability] = useState(false);
  const [showUsedGoods, setShowUsedGoods] = useState(false);
  const [debitTotal, setDebitTotal] = useState(0);
  const [creditTotal, setCreditTotal] = useState(0);
  const [contiContabili, setContiContabili] = useState([]);
  const [reloadModal, setReloadModal] = useState(false);
  const [errors, setErrors] = useState(null);
  const [totalTaxable, setTotalTaxable] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [activeTab, setActiveTab] = useState("accounting");
  const [currentParams, setCurrentParams] = useState({});
  const [modifiedDetail, setModifiedDetail] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [lastUpdateTime, setLastUpdateTime] = useState(null);
  const [isLastDetail, setIsLastDetail] = useState(false);
  const [isFirstDetail, setIsFirstDetail] = useState(false);
  const [currentDetailIndex, setCurrentDetailIndex] = useState(0);
  const [isMonoRegime, setIsMonoRegime] = useState(null);
  const [showFiscalPayments, setShowFiscalPayments] = useState(false);
  const [isCreatingNewLine, setIsCreatingNewLine] = useState(null);
  const [isClosingDrawer, setIsClosingDrawer] = useState(false);
  const [contoSelected, setContoSelected] = useState("");
  /** Lo uso con il perverso intento di riaprire la riga da cui ho draggato l'articolo */
  const [dragArticleConto, setDragArticleConto] = useState(null);

  useEffect(() => {
    setIsFromAccountantPage(location?.state?.isFromAccountantTable);
  }, [location]);

  useEffect(() => {      
    dispatch(getVatExemptions(""));
    dispatch(clearAccountArticles());
    dispatch(clearDetailAccounts());
    if (!isCreate) {
      if (!draftIds || draftIds?.length === 0) {
        dispatch(getDashboardData(
          null, location?.state?.categories, location?.state?.docNumberfilter, location?.state?.accountCodeFilter, 
          location?.state?.includesFilter?.length > 0 ? location?.state?.includesFilter : null, location?.state?.isActiveValue, location?.state?.dateFrom, location?.state?.dateTo, null, false
        ));
      }
    } else {
      dispatch(getReasons());
    }
    /** Per ora mostro il tab incassi e pagamenti solo se provendo dal tab "da contabilizzare" */
    setShowFiscalPayments(!location?.state?.accountedFor);

    return () => {
      clearInterval();      
    };
  }, []);

  useEffect(() => {    
    /* gestisce la visibilità del tab beni usati quando cambia la testata */
    setShowUsedGoods(detail?.hasUsedGoods);
  }, [detail?.id, detail?.hasUsedGoods]);

  useEffect(() => {
    /* gestisce la visibilità del tab beni usati quando 
    viene attivato margine ordinario e ho articoli */    
    if (newDetail?.regimeId !== "MARGINE_ORDINARIO") {
      setShowUsedGoods(false); 
      return;
    }
    const hasArticles = accounts?.accountingLinesByCodeApiResList?.find(el => {
      return el?.hasChildren === true;
    });    
    
    setShowUsedGoods(!!hasArticles);
  }, [newDetail?.regimeId, accounts?.accountingLinesByCodeApiResList]);
  
  useEffect(() => {
    setReloadModal(false);
    
    if (!isCreate) {        
      setDrafIdByUrl(location.pathname.split("precog-detail/")[1]);      
    }
    return () => {      
      /* fix bug Test : ogni volta che si passa da un dettaglio all'altro pulisco reloadModal
      per evitare che appaia la modale del "sei sicuro" dopo cambio precedente del regime */
      setReloadModal(false);
    };
  }, [location.pathname]);

  useEffect(() => {    
    if (!drafIdByUrl) return undefined;        
    dispatch(getDetailAccounts(drafIdByUrl));
    dispatch(getVatLines(drafIdByUrl));  
    return () => {
      dispatch(clearVatLines());
      dispatch(clearInvoiceDetail());
    };
  }, [drafIdByUrl]);

  useEffect(() => {   
          
    dispatch(getDetailAccounts(drafIdByUrl || newDetail.id));  
    return undefined;      
  }, [newDetail?.customerTaxId, 
    newDetail?.supplierTaxId, 
    newDetail?.amount]);
    
  useEffect(() => {
    // se active non presente deve passare null;
    let saleOrPurchase;
    if (typeof detail?.doc?.active !== "undefined"){
      if (detail?.doc?.active){
        saleOrPurchase = "active";
      } else {
        saleOrPurchase = "passive";
      }
    }
    if (detail?.factType === "DOCUMENT") {
      dispatch(getReasons());
    } else {
      dispatch(getReasons(detail?.factType, saleOrPurchase));
    }
    dispatch(getVatDestinations(saleOrPurchase === "active" ? "true" : "false"));
    dispatch(getVatCompensation());
    dispatch(getVatFlatRates());
    if (detail?.deadlineIdList) {
      detail.deadlineIdList.map(el => dispatch(getDeadlineDetail(el)));
    }
    setNewDetail(detail
      ? {
        ...detail,
        refCurrency: detail?.refCurrency,
        vatCollectability: detail?.vatCollectability ? detail.vatCollectability.toLowerCase() === "split" ? "split_payment" : detail.vatCollectability.toLowerCase()
          : "ordinary",
        registrationDate: detail.registrationDate
          ? moment(detail.registrationDate * 1000)
          : moment(detail?.doc?.date)
      }
      : { refCurrency: detail?.refCurrency });
    if (detail?.reasonId) {
      onReasonChange(detail?.reasonId);
    }
    let newWithHoldings = [];
    if (detail?.withHoldingLines) {
      detail.withHoldingLines.map(withHolding => {
        let title = `${withHolding.reasonCode} - ${withHolding.reasonDesc}`;
        return newWithHoldings.push({
          ...withHolding,
          rowId: uuidv4(),
          title: title
        });
      });
    }
    // setWithHoldingNew(newWithHoldings);
    setIsMonoRegime(detail?.regimeId);
  }, [detail?.reasonId, detail?.withHoldingLines, detail?.deadlineIdList,detail?.factType, detail?.doc?.active]);
  
  useEffect(() => {        
    if (!detail?.doc.id || detail?.source !== "B2B") return;
    dispatch(openEinvoicePreview(detail?.doc.id, einvoiceType));
  }, [detail, einvoiceType]);

  useEffect(() => {
    if (!download.status.ended || !download.content) return;
    startDownloadData(download);
    dispatch(resetDownloadDocument());
  }, [download]);

  useEffect(() => {  
    if ((modifiedDetail?.accountingLine && !Array.isArray(modifiedDetail?.accountingLine) && modifiedDetail?.modifiedData?.accountCode) || isCreatingNewLine) {
      let currentIndex;
      let currentAccount;
      if (modifiedDetail?.newCode) {
        currentIndex = contiNew.findIndex(conto => conto.uuid === modifiedDetail.newCode);
        currentAccount = accounts?.accountingLinesByCodeApiResList.find(el => el.uuid === modifiedDetail.newCode);
      } else {
        currentIndex = contiNew.findIndex(conto => conto.uuid === isCreatingNewLine);
        currentAccount = accounts?.accountingLinesByCodeApiResList.find(el => el.uuid === isCreatingNewLine);
      }
      if (currentIndex !== -1) {
        let clonedConti = [...contiNew];
        clonedConti[currentIndex].isPosting = currentAccount?.isPosting;
        clonedConti[currentIndex].isAsset = currentAccount?.isAsset;
        clonedConti[currentIndex].disabled = currentAccount?.disabled;
        clonedConti[currentIndex].credit = currentAccount?.credit;
        clonedConti[currentIndex].debit = currentAccount?.debit;
        setContiNew(clonedConti);
        setIsCreatingNewLine(null);
      }
      // per la modifica al saldo quando viene cambiata l'accountingLines
      setModifiedDetail(null);
    } else {
      setContiContabili(accounts);
    }
    /** !!! lasciare solo accounts che è un object non fa scattare l'hook in caso di cambiamento nell'array */
  }, [[JSON.stringify(accounts?.accountingLinesByCodeApiResList)]]);

  useEffect(() => {
    if (activeTab !== "accounting") return;
    
    dispatch(getDetailAccounts(drafIdByUrl));
  }, [activeTab]);

  useEffect(() => {
    if (!isClosingDrawer) return;
    
    dispatch(getDetailAccounts(newDetail.id)).then(() => setIsClosingDrawer(false));
  }, [isClosingDrawer]);

  useEffect(() => {
    if (!contiNew || !isCreatingNewLine) return;
    
    dispatch(getDetailAccounts(newDetail.id));
  }, [contiNew, isCreatingNewLine, isClosingDrawer]);

  useEffect(() => {
    const currentIndex = draftIds?.findIndex(el => el === detail?.id);
    setCurrentDetailIndex(currentIndex);
    setIsLastDetail(currentIndex === draftIds?.length - 1);
    setIsFirstDetail(currentIndex === 0);
  }, [detail, draftIds]);

  useEffect(() => {
    if (lastUpdate){
      // salvo subito per poi aggiornare ogni minuto
      setLastUpdateTime(moment(lastUpdate).fromNow());
    }
    window.setInterval(() => {
      if (lastUpdate) {
        setLastUpdateTime(moment(lastUpdate).fromNow());
      }
    }, 60000);
  }, [lastUpdate]);

  useEffect(() => { 
    if (modifiedDetail && !reloadModal) {
      if (modifiedDetail.accountingLine) {
        dispatch(updateAccountingLine(
          newDetail.id,
          modifiedDetail.accountingLine, modifiedDetail.modifiedData,
          modifiedDetail.parentId,
          modifiedDetail.totalAmountForCO1
        )).then(res => {     
          if ((Array.isArray(modifiedDetail.accountingLine) && modifiedDetail.modifiedData.accountCode) || modifiedDetail.modifiedData.accountCode) {
            if (!modifiedDetail.isArticleDrawer) {
              
              dispatch(getDetailAccounts(newDetail.id));
            } else {
              let credit = 0;
              let debit = 0;
              modifiedDetail.accountingLine.map(el => {
                let current = accountArticles?.elements.find(article => article.uuid === el);
                credit += current.credit || 0;
                debit += current.debit || 0;
              });
              let newId = getGroupId(
                modifiedDetail.modifiedData.accountCode, debit, credit
              );
              let contiNewClone = contiNew;
              contiNewClone.find(el => el.uuid === modifiedDetail.contoSelected).uuid = newId;
              setContiNew(contiNewClone);
              dispatch(getAccountArticles(newDetail.id, newId)).then(() => {
                setContoSelected(newId);
                
              });
            }
          }
          if (modifiedDetail.isModifiedDrawer) {
            const newLines = modifiedDetail.accountingLine;
            contiContabili.map(el => {
              const currentIndex = newLines.findIndex(conto => conto.uuid === el.uuid);
              if (currentIndex === -1) {
                newLines.push(el);
              }
              return newLines;
            });
            setContiContabili(newLines);
          }
          dispatch(getVatLines(newDetail.id));
          setLastUpdate(moment());
          setLastUpdateTime(moment().fromNow());
          if (!accountsToRefresh) {
            
            dispatch(getDetailAccounts(newDetail.id)).then(() => {
              dispatch(getAccountArticles(newDetail.id, modifiedDetail.parentId)).then(() => dispatch({ type: "SET_ACCOUNTS_REFRESH" }));
            });
          }
        });
      } else {
        dispatch(updatedDetail(newDetail.id,
          modifiedDetail)).then(res => {
          let detailUpdated = {};
          if (modifiedDetail.reasonId) {
            dispatch(getDetailAccounts(newDetail.id)).then(() => {
              dispatch(getAccountArticles(newDetail.id, modifiedDetail.parentId)).then(() => dispatch({ type: "SET_ACCOUNTS_REFRESH" }));
            });
          }
          if (modifiedDetail.accountingLines) {
            detailUpdated = {
              ...newDetail,
              ...res,
              accountingLines: modifiedDetail.accountingLines
            };
          } else {
            detailUpdated = { ...newDetail, ...modifiedDetail };
          }
          setLastUpdate(moment());
          setLastUpdateTime(moment().fromNow());          
          setNewDetail(detailUpdated);
          // ricarico le righe contabili a meno che non stia cambiando il toggle per privati
          if (!modifiedDetail.hasOwnProperty("isPrivateSale")){   
                                 
            dispatch(getDetailAccounts(newDetail?.id));
          }
          // setContiContabili(detailUpdated.accountingLines);
          setReloadModal(false);
          setModifiedDetail(null);
        });
      }
    }
  }, [modifiedDetail]);

  useEffect(() => {
    if (newDetail.reasonId) {
      dispatch(getVatRegimes(newDetail.reasonId));
    }
  }, [newDetail.reasonId]);

  const goBackToList = () => {
    navigate(backUrlLink);
  };

  const onSave = () => {
    let detailToSave = {};
    let accountingLines = [];
    let unMergedLines = [];
    unMergedLines = unmergeAccountingLines(contiNew);
    unMergedLines.map(el => {
      if (el.debit !== 0 || el.credit !== 0) {
        accountingLines.push({
          ...el,
          accountDesc: el.accountDesc,
          accountCode: el.accountCode,
          debit: el.debit,
          credit: el.credit,
          currency: "EUR",
          uuid: el.uuid,
          regimeId: el.regimeId,
          regimeExtraField: el.regimeExtraField,
          vatDestination: el.vatDestination,
          endPeriodDate: el.endPeriodDate
            ? typeof el.endPeriodDate === "number"
              ? moment
                .unix(el.endPeriodDate)
                .format("YYYY-MM-DDT02:00:00.000\\Z")
              : el.endPeriodDate.format("YYYY-MM-DDT02:00:00.000\\Z")
            : undefined,
          startPeriodDate: el.startPeriodDate
            ? typeof el.startPeriodDate === "number"
              ? moment
                .unix(el.startPeriodDate)
                .format("YYYY-MM-DDT02:00:00.000\\Z")
              : el.startPeriodDate.format("YYYY-MM-DDT02:00:00.000\\Z")
            : undefined
        });
      }
      return accountingLines;
    });
    detailToSave = {
      ...newDetail,
      accountingLines: accountingLines,
      vatLines: vatLines,
      registrationDate: newDetail.registrationDate
        ? moment(newDetail.registrationDate).format("YYYY-MM-DDT02:00:00.000\\Z")
        : "",
      doc: {
        ...newDetail.doc,
        date: newDetail.doc?.date
          ? moment(newDetail.doc.date).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD")
      },
      refCurrency: "EUR"
    };
    let currentErrors = checkErrors(detailToSave);
    setErrors(currentErrors);
    if (!currentErrors) {
      if (isCreate) {
        dispatch(createNewInvoice(detailToSave)).then(res => {          
          dispatch(displaySuccessToast("Registrazione contabile presa in carico", ""));
        });
        navigate("/precog");
        return;
      }
      dispatch(confirmInvoice(newDetail.id)).then(res => {
        dispatch(displaySuccessToast("Registrazione contabile presa in carico", ""));
      });

      /** Per poter procedere alla prossima al contabilizza vado a recuperare l'indice corrente */

      const splittedUrl = location?.pathname?.split("/");
      const currentInvoiceId = splittedUrl[splittedUrl.length - 1];
      const currentInvoiceIndex = draftIds?.findIndex(el => el === currentInvoiceId);
      if (currentInvoiceIndex < draftIds?.length - 1) {
        // se ho altro da contabilizzare vado alla prossima
        changeDetail(1);
      } else {
        // altrimenti torno indietro
        navigate(backUrlLink || "/precog");
      }
    }
  };

  const checkAndSetErrors = current => {
    let currentErrors = checkErrors(current);
    setErrors(currentErrors);
  };

  const onReasonChange = value => {
    setShowWithholding(false);
    setShowvatCollectability(false);

    const current = getReasonParams(value);
    setCurrentParams(current);

    const sections = checkReasonChange(value);

    if (sections.indexOf("intrastat") > -1) {
    }
    if (sections.indexOf("withholding") > -1) {
      setShowWithholding(true);
    }
    if (sections.indexOf("vatCollectability") > -1) {
      setShowvatCollectability(true);
    }
    if (newDetail.id) {
      
      setReloadModal(true);
    } else if (isCreate) {
      setNewDetail({ ...newDetail, reasonId: value });
      errors?.reasonId && checkAndSetErrors({ ...newDetail, reasonId: value });
    }
  };

  const changeDetail = changeIndex => {
    const currentIndex = draftIds?.findIndex(el => el === detail.id);
    const newIndex = currentIndex + changeIndex;
    const newDetailId = draftIds[newIndex];
    navigate({pathname: "/precog-detail/" + newDetailId, search: location.search});
  };

  const reloadDetail = () => {    
    if (modifiedDetail?.regimeId) {
      if (modifiedDetail?.regimeId === "MULTI") {
        setIsMonoRegime(modifiedDetail.regimeId);
        setReloadModal(false);
        setModifiedDetail(null);
        setNewDetail({...newDetail, regimeId: "MULTI"});
      } else {
        dispatch(updateRegime(newDetail.id,
          modifiedDetail)).then(res => {
          let detailUpdated = { ...newDetail,  
            registrationDate: res.registrationDate ? moment(res.registrationDate * 1000) : moment(newDetail.registrationDate), 
            regimeId: modifiedDetail?.regimeId };
          dispatch(getVatLines(newDetail.id));   
                 
          dispatch(getDetailAccounts(newDetail.id));          
          setNewDetail(detailUpdated);
        });
      }
      setLastUpdate(moment());
      setLastUpdateTime(moment().fromNow());
      dispatch(getVatLines(newDetail.id));
      setIsMonoRegime(modifiedDetail.regimeId);
      setReloadModal(false);
      setModifiedDetail(null);
    } else if (modifiedDetail?.reasonId) {
      dispatch(updatedDetail(newDetail.id,
        modifiedDetail)).then(res => {
        let detailUpdated = {};
        if (modifiedDetail.reasonId) {
          dispatch(getDetailAccounts(newDetail.id)).then(() => {
            dispatch(getAccountArticles(newDetail.id, modifiedDetail.parentId)).then(() => dispatch({ type: "SET_ACCOUNTS_REFRESH" }));
          });
        }
        if (modifiedDetail.accountingLines) {
          detailUpdated = {
            ...newDetail,
            ...res,
            accountingLines: modifiedDetail.accountingLines
          };
        } else {
          detailUpdated = { ...newDetail, reasonId: modifiedDetail?.reasonId  };
        }
        setLastUpdate(moment());
        setLastUpdateTime(moment().fromNow());        
        setNewDetail(detailUpdated);
        setReason(modifiedDetail?.reasonId);
        // setContiContabili(detailUpdated.accountingLines);        
        setReloadModal(false);
        setModifiedDetail(null);
      });
    } 
  };

  return (
    
    <div className="pre-cog-detail-page">
      
      {isGettingDetail || (modifiedDetail?.reasonId && isUpdatingDetail) ? (
        <LoaderSimple />
      ) : 
        (
          <>
            <div className="pre-cog-detail-header">
              {
                newDetail.reasonId !== "GD" ?
                  <InfoHeader 
                    changeDetail={changeDetail}
                    createReason={createReason}
                    currentDetailIndex={currentDetailIndex} 
                    currentParams={currentParams}     
                    formByReason={formByReason}         
                    invoicesLength={draftIds?.length}
                    isCreate={isCreate}
                    isFirstDetail={isFirstDetail}
                    isLastDetail={isLastDetail}                    
                    newDetail={newDetail}       
                    reasonsActive={reasonsActive}    
                    sectionalError={sectionalError}
                    setSectionalError={setSectionalError}
                    setLastUpdate={setLastUpdate}  
                    setModifiedDetail={setModifiedDetail}                    
                    setNewDetail={setNewDetail} 
                    setReloadModal={setReloadModal}
                    setReason={setReason}
                    totalTax={totalTax}
                    totalTaxable={totalTaxable}
                    setPreviewModal={setPreviewModal}
                    einvoiceType={einvoiceType}
                  />
                  : 
                  <SelectReasonsForm newDetail={newDetail} setLastUpdate={setLastUpdate}
                    setNewDetail={setNewDetail}
                    setReason={setReason} />
              }
            </div>
            {
              newDetail.reasonId !== "GD" &&
            <div className="pre-cog-detail-container">
              <DetailTabs activeTab={activeTab} 
                setSectionalError={setSectionalError}
                contiNew={contiNew} 
                setActiveTab={setActiveTab}
                showFiscalPayments={newDetail?.hasPayment}
                showIntrastat={newDetail.hasIntrastat} 
                showUsedGoods={showUsedGoods}
                showWithholding={showWithholding || newDetail?.hasWithHoldings} />
              {activeTab === "accounting" && (
                <ContiContabiliTable
                  setIsCreatingNewLine={setIsCreatingNewLine}
                  dragArticleConto={dragArticleConto}
                  setDragArticleConto={setDragArticleConto}
                  contiContabili={contiContabili}                                
                  newDetail={newDetail}
                  contiNew={contiNew}
                  setContiNew={setContiNew}
                  // setResidue={setResidue}                
                  debitTotal={debitTotal}
                  creditTotal={creditTotal}
                  setDebitTotal={setDebitTotal}
                  setCreditTotal={setCreditTotal}
                  errors={errors}
                  showRegime={!newDetail.regimeId}
                  setModifiedDetail={setModifiedDetail}
                  setIsClosingDrawer={setIsClosingDrawer}
                  setIsMonoRegime={setIsMonoRegime}
                  isMonoRegime={isMonoRegime}
                  contoSelected={contoSelected}
                  setContoSelected={setContoSelected}
                />
              )}
              {
                showUsedGoods && activeTab === "usedGoods" && (
                  <UsedGoods draftId={newDetail?.id} currency={newDetail?.refCurrency} />
                )
              }
              {newDetail.hasWithHoldings && activeTab === "withholding" && (
                <>
                  <Withholding
                    docDetail={newDetail}
                    setModifiedDetail={setModifiedDetail}
                    totalTaxable={totalTaxable}
                  />
                </>
              )}
              {(newDetail.hasIntrastat && activeTab === "intrastat") && (
                <div style={{ marginTop: 40 }}>
                  <Intrastat docTotal={newDetail?.amount} draftId={newDetail?.id} isSaleInvoice={newDetail?.doc?.active} docDate={newDetail.registrationDate} />
                </div>
              )}
              {contiNew.some(c => c.isAsset) && activeTab === "asset" && (
                <div className="pre-cog-detail-title" style={{ marginTop: 40 }}>
                  <Assets isBusinessIdSelected={!!newDetail.businessId} businessId={newDetail.businessId} />
                </div>
              )}
              {vatLines.status.started ? <LoaderSimple /> :
                (vatLines?.list.length > 0 ) &&
              activeTab === "accounting" && (
                  <>
                    <div
                      className="pre-cog-detail-title"
                      style={{ marginTop: 40 }}
                    >
                      <FormattedMessage id="preCog.vatTab.vat" />
                    </div>
                    <ContiIvaTable  
                      regimeId={newDetail.regimeId}
                      contiIva={vatLines?.list}           
                      showvatCollectability={showvatCollectability}
                      totalTaxable={totalTaxable}
                      setTotalTaxable={setTotalTaxable}
                      totalTax={totalTax}
                      setTotalTax={setTotalTax}                    
                    />
                  </>
                )}
              {
                showFiscalPayments && activeTab === "fiscal_payments" &&
              <FiscalPayments newDetail={newDetail} 
                reasonsActive={reasonsActive} createReason={createReason} 
                totalInvoice={newDetail?.amount ? newDetail.amount : 0} />
              }
              <BottomBar              
                handleSubmit={() => onSave()}
                lastUpdateTime={lastUpdateTime}
                goBackToList={goBackToList}         
                isFromRegistration={isFromRegistration}
              />
            </div>
            }
            <PreviewDocumentModal isImage={newDetail?.factType === "DOCUMENT"} previewModal={previewModal}
              einvoiceType={einvoiceType} setEinvoiceType={setEinvoiceType}
              setPreviewModal={setPreviewModal} isDashboard={false}/>
            <ReloadModal reloadDetail={reloadDetail} reloadModal={reloadModal}
              setReloadModal={setReloadModal} />
          </>
        )}      
    </div>
  );
};

export default PreCogDetailPage;
